import { TransactionalManagementIndicators } from "src/app/ui/models/domains/pbm/transactional-management/transactional-management-indicators";
import { AbstractParser } from "../../parser";
import { parseIndicators } from "./transaction-management-parse-functions";

export class IndicatorsParser extends AbstractParser<TransactionalManagementIndicators> {
  parse(payload: any) {
    return parseIndicators(payload);
  }
}
